import { createContext } from 'react';

const ChatMessagesContext = createContext([[]]);
const ChatCardsSectionScrollContext = createContext({});

export { ChatMessagesContext, ChatCardsSectionScrollContext };
